"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCertsDir = exports.setContainerName = exports.setBuilderName = exports.setStandalone = exports.setDebug = exports.certsDir = exports.containerName = exports.builderName = exports.standalone = exports.IsDebug = void 0;
const core = __importStar(require("@actions/core"));
exports.IsDebug = !!process.env['STATE_isDebug'];
exports.standalone = process.env['STATE_standalone'] || '';
exports.builderName = process.env['STATE_builderName'] || '';
exports.containerName = process.env['STATE_containerName'] || '';
exports.certsDir = process.env['STATE_certsDir'] || '';
function setDebug(debug) {
    core.saveState('isDebug', debug);
}
exports.setDebug = setDebug;
function setStandalone(standalone) {
    core.saveState('standalone', standalone);
}
exports.setStandalone = setStandalone;
function setBuilderName(builderName) {
    core.saveState('builderName', builderName);
}
exports.setBuilderName = setBuilderName;
function setContainerName(containerName) {
    core.saveState('containerName', containerName);
}
exports.setContainerName = setContainerName;
function setCertsDir(certsDir) {
    core.saveState('certsDir', certsDir);
}
exports.setCertsDir = setCertsDir;
